import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pg_admin_token");
  if (token) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PG_PHONE = "+1 (929) 667-5088";
export const PG_PHONE_TEL = "+19296675088";
export const PG_EMAIL = "primeglobecleaners@gmail.com";
export const PG_BRAND = "PRIMEGLOBE";
export const PG_LEGAL = "Prime Globe Deep Cleaning LLC";
export const PG_LOCATION = "New York, NY";
